import React from 'react';
import TrackableButton from 'src/viewLayer/components/shared/TrackableButton';
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext';
import { getOauthSignupURL } from 'src/dataLayer/env';

export default ({ appType, provider }) => {
  const { locale } = useRouteParamsContext();

  return (
    <TrackableButton
      variant="secondary"
      iconstart={provider}
      trackingId={`${appType}:${provider}`}
      href={getOauthSignupURL(locale, provider)}
      data-testid={`oauthButton-${provider}`}
    />
  );
};
